var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('v-container',{staticClass:"text-center pa-8"},[_c('h2',[_vm._v("Hubo un error al cargar el portal")]),_c('p',[_vm._v("Inténtalo de nuevo")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.reload}},[_vm._v(" Reintentar ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }